module.exports = __webpack_public_path__ + "static/media/jobrank-logo.a9f39bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/jobrank-logo.png
// module id = 32
// module chunks = 0